import { formatWithSeparators } from "../../../misc";

export const formatPrice = (value) => {
    const number = Number(value);
    return formatWithSeparators(number.toFixed(2));
};
  
export const formatDate = (date) => {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${day}/${month.toString().padStart(2, '0')}/${year}`;
}


// WEBPACK FOOTER //
// ./src/c/PremiumKeys/Globals/GlobalUtils.js